<template>
  <div class="product-managements-container">
    <div class="menu-tabs">
      <div
        v-for="(item, index) in tabMenuItems"
        :key="index"
        class="tab"
        :class="selectedTab === item.id ? 'is-tab-selected' : ''"
        @click="
          $router.push({
            query: { item: index },
          })
        "
      >
        {{ item.name }}
      </div>
    </div>
    <div v-if="$route.query.featureSettingId === undefined">
      <generic-table
        v-if="tableHeader.length > 0"
        :tableHeader="tableHeader"
        :tableData="data"
        :edit="edit"
        :showRemoveBtn="showRemoveBtn"
        :showAddBtn="showAddBtn"
        :remove="remove"
        :label="selectedLabel"
        :newItem="newItem"
        :haveSort="selectedMenuItem.haveSort"
        :changeSort="changeSort"
        :headerParentId="tabMenuItems[menuItemIndex].id"
        :onLoadFilterDate="onLoadFilterDateValue"
        @filterDataAfterChange="filterDataChanged"
        @activationToggled="activationCheck($event)"
        @dateToggle="dateChecker($event)"
        @rowCopied="isRowCopied($event)"
      />
    </div>
    <div v-else>
      <product-describing-form
        :clickedNewItemBtn="clickedNewItemBtn"
        :fullData="data"
        :selectbox-items="getFilterList"
        :cost-multiplier="costMultiplier"
        @submit-form="submitform"
      />
    </div>
    <modal height="auto" class="modal" :name="'modal'">
      <div class="modal-heading">
        <div class="modal-title">
          <h5 v-if="clickedNewItemBtn">{{ selectedData.name }} EKLE</h5>
          <h5 v-else>{{ selectedData.name }} DÜZENLE</h5>
        </div>
        <a @click="closeModal">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <component
        v-if="selectedMenuItem !== null && formReRender"
        :is="selectedMenuItem.formName"
        :clickedNewItemBtn="clickedNewItemBtn"
        :selectedDataApplicationId="selectedDataApplicationId"
        :selectedDataPlatformId="selectedDataPlatformId"
        :selectedDataResearchId="selectedDataResearchId"
        :selectedDataId="selectedDataId"
        :selectedDataName="selectedDataName"
        :selectedDataDepth="selectedDataDepth"
        :selectedDataOrder="selectedDataOrder"
        :selectedShortContent="selectedShortContent"
        :selectedDescription="selectedDescription"
        :isAgreementMandatory="isAgreementMandatory"
        :isHighLevel="isHighLevel"
        :isExternalPurchasable="isExternalPurchasable"
        :isConnectMainProduct="isConnectMainProduct"
        :selectedDataPrice="selectedDataPrice"
        :selectedDataPriceCostMultiplier="selectedDataPriceCostMultiplier"
        :selectedDataScreenPrice="selectedDataScreenPrice"
        :selectedDataCost="selectedDataCost"
        :selectedDataFundAmount="selectedDataFundAmount"
        :selectedDataCommissionAmount="selectedDataCommissionAmount"
        :selectedDataVdProducrtWarnings="selectedDataVdProducrtWarnings"
        :selectedforeignIndiceId="selectedforeignIndiceId"
        :selectedPriceType="selectedPriceType"
        :headerParentId="tabMenuItems[menuItemIndex].id"
        :additionalWarnings="additionalWarnings"
        @submit-form="submitform"
      ></component>
    </modal>
    <modal height="auto" class="modal" :name="'deleteModal'">
      <div class="modal-heading">
        <div class="modal-title">
          <h5>{{ selectedDeleteName }}</h5>
        </div>
        <a @click="$modal.hide('deleteModal')">
          <base-icon class="close" name="close-circle" />
        </a>
      </div>
      <div class="modal-body">{{ deleteInfoText }}</div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('deleteModal')"
          >Vazgeç</base-button
        >
        <base-button @click="removeModalC(selectedId)" class="delete red"
          >Sil</base-button
        >
      </div>
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import GenericTable from "../components/productAndPackage/GenericTable.vue";
import { BaseIcon, BaseButton } from "@/components";
import VendorDefination from "../components/productAndPackage/VendorDefinitionForm.vue";
import DataGroupDefinition from "../components/productAndPackage/DataGroupDefinitionForm.vue";
import PlatformDefinition from "../components/productAndPackage/PlatformDefinitionForm.vue";
import AlgoDefinition from "../components/productAndPackage/AlgoDefinitionForm.vue";
import PerspectiveDefinition from "../components/productAndPackage/PerspectiveDefinitionForm.vue";
import AkdDefinition from "../components/productAndPackage/AkdDefinitionForm.vue";
import MarketDefinition from "../components/productAndPackage/MarketDefinitionForm.vue";
import ProductDescribingForm from "@/components/productAndPackage/ProductDescribingForm";
import ResearchDefinitionForm from "@/components/productAndPackage/ResearchDefinitionForm";
import ForeignIndicesForm from "@/components/productAndPackage/ForeignIndicesForm";

export default {
  name: "ProductAndPackageManagement",
  data() {
    return {
      selectedDeleteName: "",
      deleteInfoText: "İlgili kaydı silmek istediğinizden emin misiniz?",
      selectedId: 7,
      selectedData: [],
      application: {},
      selectedDataApplication: {},
      selectedDataPlatform: {},
      applicationId: 0,
      researchId: 0,
      selectedDataApplicationId: 0,
      selectedDataPlatformId: 0,
      selectedforeignIndiceId: 0,
      selectedDataResearchId: 0,
      selectedDataId: 7,
      selectedDataName: "",
      selectedDataDepth: 0,
      selectedShortContent: "",
      selectedDescription: "",
      selectedPriceType: 1,
      order: 7,
      selectedDataOrder: 7,
      isAgreementMandatory: false,
      isHighLevel: false,
      isExternalPurchasable: false,
      isConnectMainProduct: false,
      selectedDataPrice: 850,
      selectedDataPriceCostMultiplier: 0,
      selectedDataScreenPrice: 0,
      selectedDataCost: 0,
      selectedDataFundAmount: 1880000,
      selectedDataCommissionAmount: 1410,
      selectedDataVdProducrtWarnings: [""],
      additionalWarnings: [""],
      selectedTab: 1,
      selectedLabel: "Veri Grubu",
      tableHeader: [],
      showRemoveBtn: true,
      showAddBtn: true,
      clickedNewItemBtn: false,
      data: [],
      onLoadFilterDateValue: null,
      tabMenuItems: [
        {
          id: 1,
          name: "VERİ GRUBU İŞLEMLERİ",
          label: "Veri Grubu",
          actionNames: [
            "getAllApplicationTypes",
            "updateApplicationType",
            "createApplicationType",
            "deleteApplicationType",
            "changeApplicationTypeOrderDecrease",
            "changeApplicationTypeOrderIncrease",
          ],
          tableHeaderProp: "dataGroupHeader",
          formName: "DataGroupDefinition",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: null,
          haveSort: true,
        },
        {
          id: 2,
          name: "İŞLEM YERİ İŞLEMLERİ",
          label: "İşlem Yeri",
          actionNames: [
            "getAllPlatforms",
            "updatePlatform",
            "createPlatform",
            "deletePlatform",
            "changePlatformOrderDecrease",
            "changePlatformOrderIncrease",
          ],
          tableHeaderProp: "platformHeader",
          formName: "PlatformDefinition",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: null,
          haveSort: true,
        },
        {
          id: 3,
          name: "DERİNLİK İŞLEMLERİ",
          label: "Derinlik",
          actionNames: [
            "getAllPerspectives",
            "updatePerspective",
            "createPerspective",
            "deletePerspective",
            "changePerspectiveOrderDecrease",
            "changePerspectiveOrderIncrease",
          ],
          tableHeaderProp: "perspectiveHeader",
          formName: "PerspectiveDefinition",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: null,
          haveSort: true,
        },
        {
          id: 4,
          name: "AKD İŞLEMLERİ",
          label: "AKD",
          actionNames: [
            "getAllAKDs",
            "updateAKD",
            "createAKD",
            "deleteAKD",
            "changeAkdOrderDecrease",
            "changeAkdOrderIncrease",
          ],
          tableHeaderProp: "akdHeader",
          formName: "AkdDefinition",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: null,
          haveSort: true,
        },
        {
          id: 5,
          name: "PİYASA İŞLEMLERİ",
          label: "Piyasa",
          actionNames: [
            "getAllMarkets",
            "updateMarket",
            "createMarket",
            "deleteMarket",
            "changeMarketOrderDecrease",
            "changeMarketOrderIncrease",
          ],
          tableHeaderProp: "marketHeader",
          formName: "MarketDefinition",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: null,
          haveSort: true,
        },
        {
          id: 6,
          name: "ALGORİTMALAR-DİĞER İŞLEMLER",
          label: "Algoritmalar-Diğer İşlemler",
          actionNames: [
            "getAllAlgorithmAndServers",
            "updateAlgorithmAndServer",
            "createAlgorithmAndServer",
            "deleteAlgorithmAndServer",
            "changeAlgorithmAndServerOrderDecrease",
            "changeAlgorithmAndServerOrderIncrease",
          ],
          tableHeaderProp: "algoHeader",
          formName: "AlgoDefinition",
          showRemoveBtn: true,
          showAddBtn: false,
          reqParams: {
            year: null,
            month: null,
          },
          haveSort: true,
        },
        {
          id: 8,
          name: "ARAŞTIRMA VE DİĞER UYGULAMALAR",
          label: "Araştırma ve Diğer Uygulama",
          actionNames: [
            "getResearchList",
            "updateResearch",
            "createResearch",
            "deleteResearch",
            "changeResearchOrderDecrease",
            "changeResearchOrderIncrease",
          ],
          tableHeaderProp: "algoHeader",
          formName: "ResearchDefinitionForm",
          showRemoveBtn: true,
          showAddBtn: false,
          reqParams: {
            year: null,
            month: null,
          },
          haveSort: true,
        },
        {
          id: 9,
          name: "YABANCI ENDEKSLER",
          label: "Yabancı Endeksler",
          actionNames: [
            "getForeignList",
            "updateForeign",
            "createForeign",
            "deleteForeign",
            "changeResearchOrderDecrease",
            "changeResearchOrderIncrease",
          ],
          tableHeaderProp: "foreignHeader",
          formName: "ForeignIndicesForm",
          showRemoveBtn: true,
          showAddBtn: true,
          reqParams: {
            year: null,
            month: null,
          },
          haveSort: false,
        },
        {
          id: 7,
          name: "ÜRÜN İŞLEMLERİ",
          label: "Ürün İşlemi",
          actionNames: [
            "getFeatureSettingList",
            "updateFeatureSetting",
            "createFeatureSetting",
            "deleteFeatureSetting",
          ],
          tableHeaderProp: "featureSettingsHeader",
          formName: "ProductDescribingForm",
          showRemoveBtn: true,
          showAddBtn: false,
          reqParams: {
            applicationId: 0,
            platformId: 0,
            marketId: 0,
            perspectiveIds: [],
            vendorIds: [],
            researchIds: [],
            algorithmIds: [],
            foreignIndiceIds: [],
            cost: 0,
            screenPrice: 0,
            price: 0,
            priceType: 0,
            fundAmount: 0,
            commissionAmount: 0,
            year: null,
            month: null,
          },
        },
      ],
      vendorHeader: [
        { title: "Sıra No", column: "order" },
        { title: "Ad", column: "name" },
        { title: "Entegrasyon Türü", column: "integrationType" },
        { title: "Tarih", column: "date" },
        { title: "Veri Grubu", column: "dataGroup" },
        { title: "Son İşlem Yapan", column: "lastModifier" },
      ],
      platformHeader: [
        { title: "Adı", column: "name" },
        { title: "Kısa Tanım", column: "shortContent" },
        { title: "Açıklama", column: "description" },
      ],
      perspectiveHeader: [
        { title: "Adı", column: "name" },
        { title: "Kısa Tanım", column: "shortContent" },
        { title: "Açıklama", column: "description" },
      ],
      akdHeader: [
        { title: "Adı", column: "name" },
        { title: "Kısa Tanım", column: "shortContent" },
        { title: "Açıklama", column: "description" },
      ],
      marketHeader: [
        { title: "Adı", column: "name" },
        { title: "Kısa Tanım", column: "shortContent" },
        { title: "Açıklama", column: "description" },
      ],
      algoHeader: [
        { title: "İşlem Platformu", column: "applicationName" },
        { title: "Ürün Adı", column: "name" },
        { title: "Fiyat", column: "price" },
        { title: "Tarih", column: "updateDate" },
      ],
      foreignHeader: [
        { title: "İşlem Platformu", column: "applicationName" },
        { title: "Ürün Adı", column: "name" },
        { title: "Fiyat", column: "price" },
        { title: "Fiyat Tipi", column: "priceType" },
      ],
      dataGroupHeader: [
        /* { title: "Sıra No", column: "order" },*/
        { title: "Ad", column: "name" },
        { title: "Kısa Tanım", column: "shortContent" },
        /*{ title: "Şablon", column: "template" },*/
        { title: "Tarih", column: "date" },
        { title: "Son İşlem Yapan", column: "lastModifier" },
      ],
      featureSettingsHeader: [
        { title: "Veri Grubu", column: "applicationTypeName" },
        { title: "İşlem Platformu", column: "name" },
        { title: "Platform", column: "platformName" },
        { title: "Piyasa", column: "marketName" },
        { title: "Tarih", column: "updateDate" },
      ],
      selectedMenuItem: null,
      menuItemIndex: 0,
      filterAttributes: [],
      costMultiplier: 2.5,
      formReRender: false,
    };
  },
  components: {
    GenericTable,
    BaseButton,
    BaseIcon,
    VendorDefination,
    DataGroupDefinition,
    PlatformDefinition,
    PerspectiveDefinition,
    AkdDefinition,
    MarketDefinition,
    AlgoDefinition,
    ProductDescribingForm,
    ResearchDefinitionForm,
    ForeignIndicesForm,
  },
  methods: {
    ...mapActions([
      "getAllApplicationTypes",
      "updateApplicationType",
      "createApplicationType",
      "deleteApplicationType",
      "getAllPlatforms",
      "updatePlatform",
      "createPlatform",
      "deletePlatform",
      "getAllPerspectives",
      "updatePerspective",
      "createPerspective",
      "deletePerspective",
      "getAllAKDs",
      "updateAKD",
      "createAKD",
      "deleteAKD",
      "getAllMarkets",
      "updateMarket",
      "createMarket",
      "deleteMarket",
      "getAllAlgorithmAndServers",
      "updateAlgorithmAndServer",
      "createAlgorithmAndServer",
      "deleteAlgorithmAndServer",
      "getFeatureSettingList",
      "fillFilter",
      "createFeatureSetting",
      "getSiteSettings",
      "updateFeatureSetting",
      "deleteFeatureSetting",
      "getResearchList",
      "updateResearch",
      "createResearch",
      "deleteResearch",
      "changeApplicationTypeOrderIncrease",
      "changeApplicationTypeOrderDecrease",
      "changePlatformOrderDecrease",
      "changePlatformOrderIncrease",
      "changeAlgorithmAndServerOrderDecrease",
      "changeAlgorithmAndServerOrderIncrease",
      "changePerspectiveOrderDecrease",
      "changePerspectiveOrderIncrease",
      "changeMarketOrderDecrease",
      "changeMarketOrderIncrease",
      "changeAkdOrderDecrease",
      "changeAkdOrderIncrease",
      "getForeignList",
      "updateForeign",
      "createForeign",
      "deleteForeign",
      "changeResearchOrderDecrease",
      "changeResearchOrderIncrease",
    ]),
    ...mapMutations([
      "setProductPackageFilter",
      "setProductPackageAlgoFilter",
      "setProductPackageResearchFilter",
      "setProductPackageProductFilter",
      "setProductPackageForeignFilter",
    ]),
    updateInfoMessage() {
      this.$toast.success("İlgili Kayıt Düzenlendi");
      this.closeModal();
      this.changeTab(this.selectedMenuItem);
    },
    createInfoMessage() {
      this.$toast.success("İlgili Kayıt Eklendi");
      this.closeModal();
      this.changeTab(this.selectedMenuItem);
    },
    deleteSuccessMessage() {
      this.$toast.success("İlgili Kayıt Silindi");
      this.$modal.hide("deleteModal");
      this.changeTab(this.selectedMenuItem);
    },
    deleteErrorMessage(param) {
      this.$modal.hide("deleteModal");
      if (param != null) {
        this.$toast.error(param);
      } else {
        this.$toast.error("Bir Hata oluştu");
      }
      this.changeTab(this.selectedMenuItem);
    },
    submitform(params) {
      const actionName = this.clickedNewItemBtn
        ? this.selectedMenuItem.actionNames[2]
        : this.selectedMenuItem.actionNames[1];
      this[actionName](params).then((response) => {
        if (response.error) {
          if (response.result) {
            this.$toast.error(response.result.data[0].errors[0]);
          } else {
            this.$toast.error(response.message);
          }
        } else {
          if (this.clickedNewItemBtn) {
            this.createInfoMessage();
          } else {
            this.updateInfoMessage();
          }
          this.$router.push({
            query: { item: this.$route.query.item },
          });
        }
      });
      this.$modal.hide("modal");
    },
    isRowCopied(response) {
      this.data = response.data;
    },
    activationCheck(param) {
      if (param) {
        this.getData(this.selectedMenuItem);
      }
    },
    dateChecker(param) {
      const isNext = param === "next";
      let currentYear;
      let currentMonth;

      if (this.selectedMenuItem.id == 6) {
        currentYear = this.getManagementAlgoFilter.year;
        currentMonth = this.getManagementAlgoFilter.month;
      } else if (this.selectedMenuItem.id == 7) {
        currentYear = this.getManagementProductFilter.year;
        currentMonth = this.getManagementProductFilter.month;
      } else if (this.selectedMenuItem.id == 8) {
        currentYear = this.getManagementResearchFilter.year;
        currentMonth = this.getManagementResearchFilter.month;
      } else if (this.selectedMenuItem.id == 9) {
        currentYear = this.getManagementForeignFilter.year;
        currentMonth = this.getManagementForeignFilter.month;
      }

      const nextYear = isNext
        ? currentMonth > 11
          ? currentYear + 1
          : currentYear
        : currentMonth < 2
        ? currentYear - 1
        : currentYear;

      const nextMonth = isNext
        ? currentMonth > 11
          ? 1
          : currentMonth + 1
        : currentMonth < 2
        ? 12
        : currentMonth - 1;

      if (this.selectedMenuItem.id == 6) {
        this.setProductPackageAlgoFilter({
          year: nextYear,
          month: nextMonth,
          inputVal: new Date(nextYear + "/" + nextMonth),
        });
      } else if (this.selectedMenuItem.id == 7) {
        this.setProductPackageProductFilter({
          year: nextYear,
          month: nextMonth,
          inputVal: new Date(nextYear + "/" + nextMonth),
        });
      } else if (this.selectedMenuItem.id == 8) {
        this.setProductPackageResearchFilter({
          year: nextYear,
          month: nextMonth,
          inputVal: new Date(nextYear + "/" + nextMonth),
        });
      } else if (this.selectedMenuItem.id == 9) {
        this.setProductPackageForeignFilter({
          year: nextYear,
          month: nextMonth,
          inputVal: new Date(nextYear + "/" + nextMonth),
        });
      }

      if ([6, 7, 8, 9].includes(this.selectedMenuItem.id)) {
        this.selectedMenuItem.reqParams.year = nextYear;
        this.selectedMenuItem.reqParams.month = nextMonth;
        this.getData(this.selectedMenuItem);
      }
    },
    selectedTabItem(id) {
      this.selectedMenuItem = this.tabMenuItems.find((x) => x.id === id);
      return this.selectedMenuItem;
    },
    async changeTab(item) {
      if (item.id === 6) {
        item.reqParams.year = this.getManagementAlgoFilter.year;
        item.reqParams.month = this.getManagementAlgoFilter.month;
        this.onLoadFilterDateValue = this.getManagementAlgoFilter.inputVal;
      } else if (item.id === 9) {
        item.reqParams.year = this.getManagementForeignFilter.year;
        item.reqParams.month = this.getManagementForeignFilter.month;
        this.onLoadFilterDateValue = this.getManagementForeignFilter.inputVal;
      } else if (item.id === 8) {
        item.reqParams.year = this.getManagementResearchFilter.year;
        item.reqParams.month = this.getManagementResearchFilter.month;
        this.onLoadFilterDateValue = this.getManagementResearchFilter.inputVal;
      } else if (item.id == 7 && this.clickedNewItemBtn) {
        this.setProductPackageProductFilter({
          year: null,
          month: null,
          inputVal: null,
        });
        item.reqParams.year = null;
        item.reqParams.month = null;
        this.onLoadFilterDateValue = null;
      } else if (item.id == 7 && !this.clickedNewItemBtn) {
        this.setProductPackageProductFilter({
          year: this.getManagementProductFilter.year,
          month: this.getManagementProductFilter.month,
          inputVal: this.getManagementProductFilter.inputVal,
        });
        item.reqParams.year = this.getManagementProductFilter.year;
        item.reqParams.month = this.getManagementProductFilter.month;
        this.onLoadFilterDateValue = this.getManagementProductFilter.inputVal;
      }
      await this.getData(item);
    },
    async getData(item) {
      this.formRender = false;
      this.selectedTab = item.id;
      this.selectedLabel = item.label;
      this.showRemoveBtn = item.showRemoveBtn;
      this.showAddBtn = item.showAddBtn;
      await this[item.actionNames[0]](item.reqParams).then((response) => {
        if (item.id === 6) {
          const servers = response;
          for (const item of servers) {
            item.applicationName = item.application.name;
            item.updateDate = this.$moment(item.updatedAt).format("DD/MM/YYYY");
            if (item.year && item.month) {
              this.setProductPackageAlgoFilter({
                year: item.year,
                month: item.month,
                inputVal: null,
              });
            }
          }
          this.data = servers;
        } else if (item.id === 7) {
          const formatedData = response;
          for (const itemData of formatedData) {
            itemData.platformName = itemData?.platform?.name || "";
            itemData.platformId = itemData?.platform?.id || null;
            const marketNames = [];
            for (const license of itemData.licences) {
              marketNames.push(license.name);
            }
            itemData.marketName = marketNames.join(", "); // Use join to concatenate array elements with a separator
            itemData.updateDate = this.$moment(itemData.updatedAt).format(
              "DD/MM/YYYY"
            );
            if (itemData.year && itemData.month) {
              this.setProductPackageProductFilter({
                year: itemData.year,
                month: itemData.month,
                inputVal: null,
              });
            }
          }
          this.data = formatedData;
        } else if (item.id === 8) {
          const servers = response;
          for (const item of servers) {
            if (!item.application) {
              item.applicationName = "Ana Ürün";
            } else {
              item.applicationName = item.application.name;
            }
            item.updateDate = this.$moment(item.updatedAt).format("DD/MM/YYYY");

            if (item.year && item.month) {
              this.setProductPackageResearchFilter({
                year: item.year,
                month: item.month,
                inputVal: null,
              });
            }
          }
          this.data = servers;
        } else if (item.id === 9) {
          const servers = response;
          for (const item of servers) {
            if (!item.application) {
              item.applicationName = "Ana Ürün";
            } else {
              item.applicationName = item.application.name;
            }
            item.updateDate = this.$moment(item.updatedAt).format("DD/MM/YYYY");

            if (item.year && item.month) {
              this.setProductPackageForeignFilter({
                year: item.year,
                month: item.month,
                inputVal: null,
              });
            }
          }
          this.data = servers;
        } else {
          this.data = response;
        }
      });

      if (item.tableHeaderProp !== "") {
        this.tableHeader = this[item.tableHeaderProp];
      } else {
        this.tableHeader = [];
      }
    },
    parseDateFromString(dateString) {
      const [year, month, day] = dateString.split("T")[0].split("-");
      return { year: Number(year), month: Number(month), day: Number(day) };
    },
    getNextMonth({ year, month }) {
      if (month === 12) {
        return { year: year + 1, month: 1 };
      } else {
        return { year, month: month + 1 };
      }
    },
    filterDataChanged(args) {
      const item = this.selectedTabItem(this.selectedTab);

      const hasFilterDate = args.value;
      const dateObj = hasFilterDate
        ? this.parseDateFromString(args.value)
        : null;
      const setMonthOptions = this.getNextMonth(dateObj);

      const filterMethods = {
        6: this.setProductPackageAlgoFilter,
        7: this.setProductPackageProductFilter,
        8: this.setProductPackageResearchFilter,
        9: this.setProductPackageForeignFilter,
      };

      if (args.id in filterMethods) {
        item.reqParams.year = setMonthOptions.year;
        item.reqParams.month = setMonthOptions.month;

        const filterMethod = filterMethods[args.id];
        filterMethod({
          year: setMonthOptions.year,
          month: setMonthOptions.month,
          inputVal: args.inputVal,
        });

        this.getData(item);
      }
    },
    newItem() {
      this.formReRender = false;
      this.clickedNewItemBtn = true;
      if (this.$route.query.item != "8") {
        this.selectedData = this.selectedTabItem(this.selectedTab);
        this.selectedDataId = null;
        this.selectedDataName = "";
        this.selectedDataDepth = null;
        this.selectedDataOrder = null;

        this.applicationId = null;
        this.selectedDataApplicationId = null;
        this.selectedDataPlatformId = null;
        this.selectedDataResearchId = null;
        this.selectedforeignIndiceId = null;
        this.selectedShortContent = "";
        this.selectedDescription = "";

        this.isAgreementMandatory = false;
        this.isHighLevel = false;
        this.isExternalPurchasable = false;
        this.isConnectMainProduct = false;

        this.selectedDataPrice = null;
        this.selectedDataPriceCostMultiplier = this.costMultiplier;
        this.selectedDataScreenPrice = null;
        this.selectedDataCost = null;
        this.selectedDataFundAmount = null;
        this.selectedDataCommissionAmount = null;
        this.selectedDataVdProducrtWarnings = [];
        this.additionalWarnings = [];
        setTimeout(() => {
          this.formReRender = true;
        }, 10);
        this.openModal();
      } else {
        this.$router.push({
          query: { item: this.$route.query.item, featureSettingId: 0 },
        });
      }
    },
    edit(item) {
      this.formReRender = false;
      this.clickedNewItemBtn = false;

      if (this.$route.query.item != "8") {
        this.clickedNewItemBtn = false;
        this.selectedData = this.selectedTabItem(this.selectedTab);

        this.applicationId = item.applicationId;
        this.researchId = item.researchId;
        this.selectedDataApplicationId = item.applicationId;
        this.selectedDataPlatformId = item.platform ? item.platform.id : item.platformId;
        this.selectedforeignIndiceId = item.foreignIndiceId;
        this.selectedDataResearchId = item.researchId;
        this.selectedDataId = item.id;
        this.selectedDataName = item.name;
        this.selectedDataDepth = item.depth ? item.depth : 0;
        this.selectedDataOrder = item.order;
        this.selectedShortContent = item.shortContent;
        this.selectedDescription = item.description;
        this.isAgreementMandatory = item.isAgreementMandatory;
        this.isHighLevel = item.isHighLevel;
        this.isExternalPurchasable = item.isExternalPurchasable;
        this.isConnectMainProduct = item.isConnectMainProduct;

        this.selectedDataPrice = item.price;
        this.selectedPriceType = item.priceType;
        this.selectedDataPriceCostMultiplier = this.costMultiplier;
        this.selectedDataScreenPrice = item.screenPrice;
        this.selectedDataCost = item.cost;
        this.selectedDataFundAmount = item.fundAmount;
        this.selectedDataCommissionAmount = item.commissionAmount;
        this.selectedDataVdProducrtWarnings = item.vdProducrtWarnings;
        this.additionalWarnings = item.vdProducrtWarnings;
        setTimeout(() => {
          this.formReRender = true;
        }, 10);
        this.openModal();
      } else {
        this.$router.push({
          query: {
            item: this.$route.query.item,
            featureSettingId: item.id,
            platformId: item.platformId,
            isEditing: true,
          },
        });
      }
    },
    changeSort(item) {
      // eslint-disable-next-line no-unused-vars
      const actionName =
        item.sortType === "up"
          ? this.selectedMenuItem.actionNames[4]
          : this.selectedMenuItem.actionNames[5];
      // eslint-disable-next-line no-unused-vars
      const params = {};
      if (this.selectedMenuItem.id === 8) {
        params.id = item.researchId;
      } else {
        params.id = item.id;
      }
      this[actionName](params).then((response) => {
        const error = response.error ? false : true;
        if (response.status === 200 && error) {
          this.$toast.error("Bir Hata oluştu");
        } else {
          this.getData(this.selectedMenuItem);
        }
      });
    },
    openModal() {
      this.$modal.show("modal");
    },
    closeModal() {
      this.$modal.hide("modal");
    },
    removeModalC(selectedId) {
      let stateMonth;
      let stateYear;

      if (this.selectedData.id == 6) {
        stateMonth = this.getManagementAlgoFilter.month;
        stateYear = this.getManagementAlgoFilter.year;
      } else if (this.selectedData.id == 7) {
        stateMonth = this.getManagementProductFilter.month;
        stateYear = this.getManagementProductFilter.year;
      } else if (this.selectedData.id == 8) {
        stateMonth = this.getManagementResearchFilter.month;
        stateYear = this.getManagementResearchFilter.year;
      } else if (this.selectedData.id == 9) {
        stateMonth = this.getManagementForeignFilter.month;
        stateYear = this.getManagementForeignFilter.year;
      }
      const args = {
        id: selectedId,
        year: stateYear,
        month: stateMonth,
      };
      this[this.selectedMenuItem.actionNames[3]](args).then((response) => {
        if (!response.data.error) {
          this.deleteSuccessMessage();
        } else {
          this.deleteErrorMessage(response.data.message);
        }
      });
    },
    remove(item) {
      this.selectedData = this.selectedTabItem(this.selectedTab);
      this.selectedDeleteName = item.name;
      if (this.$route.query.item != "8") {
        this.selectedId = item.id;
      } else {
        this.selectedId = item.platform.id;
      }
      this.$modal.show("deleteModal");
    },
  },
  computed: {
    ...mapGetters([
      "allAlgorithmAndServers",
      "updateAlgorithmAndServerResponse",
      "createAlgorithmAndServerResponse",
      "deleteAlgorithmAndServerResponse",
      "allApplicationTypes",
      "updateApplicationTypeResponse",
      "createApplicationTypeResponse",
      "deleteApplicationTypeResponse",
      "allPlatforms",
      "updatePlatformResponse",
      "createPlatformResponse",
      "deletePlatformResponse",
      "allPerspectives",
      "updatePerspectiveResponse",
      "createPerspectiveResponse",
      "deletePerspectiveResponse",
      "allAKDs",
      "updateAKDResponse",
      "createAKDResponse",
      "deleteAKDResponse",
      "allMarkets",
      "updateMarketResponse",
      "createMarketResponse",
      "deleteMarketResponse",
      "getFilterList",
      "getProductManagementFilter",
      "getProductManagementAlgoFilter",
      "getProductManagementResearchFilter",
      "getProductManagementProductFilter",
      "getProductManagementForeignFilter",
    ]),
    getManagementAlgoFilter() {
      return this.getProductManagementAlgoFilter;
    },
    getManagementResearchFilter() {
      return this.getProductManagementResearchFilter;
    },
    getManagementProductFilter() {
      return this.getProductManagementProductFilter;
    },
    getManagementForeignFilter() {
      return this.getProductManagementForeignFilter;
    },
  },
  created() {},
  mounted() {
    this.selectedMenuItem = this.tabMenuItems[0];
    if (
      this.selectedMenuItem.id !== 7 &&
      this.$route.query.featureSettingId == "0"
    ) {
      this.clickedNewItemBtn = true;
    } else if (
      this.selectedMenuItem.id !== 7 &&
      this.$route.query.featureSettingId != "0"
    ) {
      this.clickedNewItemBtn = false;
    }
    this.fillFilter().then(() => {
      this.getSiteSettings().then((r) => {
        this.costMultiplier = r.costMultiplexer;
      });
    });

    this.menuItemIndex = this.$route.query.item ? this.$route.query.item : 0;
    this.selectedMenuItem = this.tabMenuItems[this.menuItemIndex];
    this.changeTab(this.selectedMenuItem);
  },

  watch: {
    getProductManagementProductFilter: {
      handler: function (newVal) {
        this.tabMenuItems[8].reqParams.year = newVal.year;
        this.tabMenuItems[8].reqParams.month = newVal.month;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.product-managements-container {
  .model-body {
    justify-content: left !important;
  }

  .form-group {
    width: 93%;
    margin: 5px 0px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
}
</style>
<style lang="scss">
.product-managements-container {
  padding-bottom: 50px;
  background-color: white;

  .menu-tabs {
    display: flex;
    border-bottom: 1px solid black;
    justify-content: space-evenly;
    @media (max-width: 1024px) {
      overflow-x: scroll;
    }

    .tab {
      cursor: pointer;
      padding: 20px 0px;
      color: #242424;
      font-size: 14px;
      border-bottom: 2px solid transparent;
      box-sizing: border-box;
      @media (max-width: 768px) {
        padding:20px;
      }
      &:first-child{
        padding-left:10px;
      }
      &:last-child{
        padding-right: 10px;
      }

      &.is-tab-selected {
        border-bottom-color: black;
      }
    }
  }

  .base-form-input {
    margin: 0 10px;

    input {
      width: 95%;
      height: 43px;
      box-shadow: none;
      border: 1px solid #ccc;
      position: relative;
    }

    label {
      width: max-content;
      top: 8px;
      margin-bottom: 0;
    }
  }

  .form-control-label,
  .base-form-input label {
    font-size: 12px;
    color: var(--grayscale-70);
    position: relative;
    padding: 0 7px;
    margin-left: 10px;
    z-index: 2;
    background: #ffffff;

    @media (min-width: 768px) and (max-width: 1024px) {
      width: 90%;
    }
  }

  .form-control-label {
    top: 10px;
  }

  .modal {
    .vm--modal {
      max-width: 600px;
      width: 100%;
      left: 0 !important;
      margin: 0 auto;

      @media (max-width: 768px) {
        width: 95% !important;
      }
    }

    .modal-heading {
      height: 40px;
      border-bottom: 1px solid var(--grayscale-30);
      display: flex;
      align-items: center;
      padding: 15px 30px;
      justify-content: space-between;

      .close {
        margin: 5px;
        cursor: pointer;
      }
    }

    .modal-bottom {
      margin-top: 1em;
      border-top: 1px solid var(--grayscale-30);
      display: flex;
      justify-content: flex-end;
      padding: 15px 30px;

      .add,
      .update {
        background-color: #28a745;
      }

      .red {
        background-color: #dc3545;
      }

      .base-button {
        width: 180px;
        font-size: 15px;
        margin-left: 10px;

        &.giveUp {
          background: none;
          color: var(--grayscale-60);
        }
      }
    }

    .modal-body {
      padding: 15px 25px;
      display: flex;
      flex-wrap: wrap;
      justify-content: left;
      align-items: center;
      overflow-y: auto;
      max-height: 277px;

      .base-form-input {
        width: 95%;
      }
    }
  }
}
</style>
